import { logDebug, logError } from "./utils/log";

const currentVersion =
  typeof import.meta.env.VITE_GIT_SHA === "string" ? import.meta.env.VITE_GIT_SHA : undefined;
let hasNewVersion = false;
let newVersion: string | undefined;

export function checkVersion(version: unknown) {
  if (currentVersion !== undefined && typeof version === "string" && version !== currentVersion) {
    logDebug(`updater: New version available: ${version} (current=${currentVersion})`);
    hasNewVersion = true;
    newVersion = version;
  }
}

const updatedToVersionKey = "updater__updatedToVersion";

export function updateIfNewVersionAvailable() {
  if (!hasNewVersion) {
    return;
  }

  const prevNewVersion = sessionStorage.getItem(updatedToVersionKey);
  if (prevNewVersion === newVersion) {
    logError("updater: trying to update to the same version twice in a row, skipping.", {
      currentVersion,
      newVersion,
    });
    return;
  }

  logDebug("updater: Reloading to get new version");
  sessionStorage.setItem(updatedToVersionKey, String(newVersion));
  window.location.reload();
  return true;
}
